import React, { useEffect } from "react";
import EmployeeRouteMap from "../../components/admin/Livelocation";
const EmployeeRouteMapPage = () => {

   useEffect(() => {
          document.body.id = "EmployeeRouteMap-002";
        }, []);
  return (
    <div>
     <EmployeeRouteMap />
    </div>
  );
};

export default EmployeeRouteMapPage;
